"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var FormText_1 = require("../FormText");
var TextArea = function (_a) {
    var label = _a.label, _b = _a.rows, rows = _b === void 0 ? 3 : _b, helpText = _a.helpText, props = __rest(_a, ["label", "rows", "helpText"]);
    var id = label + "-textarea";
    return (jsx_runtime_1.jsxs("div", __assign({ className: "form-group" }, { children: [jsx_runtime_1.jsx("label", __assign({ className: "text-capitalize", htmlFor: id }, { children: label }), void 0),
            jsx_runtime_1.jsx("textarea", __assign({ className: "form-control", id: id, rows: rows }, props), void 0),
            helpText && jsx_runtime_1.jsx(FormText_1.FormText.Help, { text: helpText }, void 0)] }), void 0));
};
exports.TextArea = TextArea;
//# sourceMappingURL=index.js.map